export default __webpack_public_path__ + "static/media/budget-color-icon.50596509.svg";